import { apiEndpoints } from "@/services/api/api";
import { HomepageLoaderData } from "@/routes/homePage/types/homePageDTO";
import { AuthlessHomepageLoaderData } from "@/routes/homePage/types/authlessHomePageDTO";
import { LoaderFunction } from "react-router-dom";
import { authService } from "@/services/auth/authService";
import { Level } from "@/routes/courses/enums/level";

export type HomepageLayoutLoaderData =
  | ({ isAuthenticated: true } & HomepageLoaderData)
  | AuthlessHomepageLoaderData;

const mockFeaturedCourses: AuthlessHomepageLoaderData["featuredCourses"] = [
  {
    id: "mock-1",
    image: "",
    name: "React ile Modern Web Geliştirme",
    description:
      "React'ın temellerinden ileri seviye konularına kadar kapsamlı bir eğitim. Hooks, Context API, ve performans optimizasyonu dahil.",
    rating: 4.8,
    totalRatings: 312,
    durationMinute: 1440,
    totalLessons: 48,
    level: Level.Beginner,
    price: 499,
    priceText: "₺499",
    discountedPrice: 499,
    discountedPriceText: "₺499",
    isCoursePurchased: false,
    isInTheBasket: false,
  },
  {
    id: "mock-2",
    image: "",
    name: "Node.js & Express ile Backend Geliştirme",
    description:
      "REST API tasarımı, veritabanı entegrasyonu ve kimlik doğrulama konularını kapsayan tam kapsamlı backend kursu.",
    rating: 4.7,
    totalRatings: 214,
    durationMinute: 1200,
    totalLessons: 40,
    level: Level.Intermediate,
    price: 599,
    priceText: "₺599",
    discountedPrice: 599,
    discountedPriceText: "₺599",
    isCoursePurchased: false,
    isInTheBasket: false,
  },
  {
    id: "mock-3",
    image: "",
    name: "Python ile Veri Bilimi ve Makine Öğrenmesi",
    description:
      "Pandas, NumPy ve Scikit-learn kütüphaneleriyle veri analizi ve makine öğrenmesi modellerini uygulamalı olarak öğrenin.",
    rating: 4.9,
    totalRatings: 428,
    durationMinute: 1680,
    totalLessons: 56,
    level: Level.Intermediate,
    price: 649,
    priceText: "₺649",
    discountedPrice: 649,
    discountedPriceText: "₺649",
    isCoursePurchased: false,
    isInTheBasket: false,
  },
];

const mockDiscountedCourses: AuthlessHomepageLoaderData["discountedCourses"] =
  [
    {
      id: "mock-disc-1",
      image: "",
      name: "TypeScript ile Full-Stack Uygulama Geliştirme",
      description:
        "TypeScript, Next.js ve Prisma kullanarak modern full-stack uygulamalar geliştirin. Gerçek dünya projeleriyle pratik yapın.",
      rating: 4.8,
      totalRatings: 189,
      durationMinute: 1560,
      totalLessons: 52,
      level: Level.Advanced,
      price: 799,
      priceText: "₺799",
      discountedPrice: 399,
      discountedPriceText: "₺399",
      isCoursePurchased: false,
      isInTheBasket: false,
    },
  ];

export const homePageLoader: LoaderFunction =
  async (): Promise<HomepageLayoutLoaderData> => {
    const isAuthenticated = !!authService.getAccessToken();

    if (isAuthenticated) {
      const response = await apiEndpoints.getHomePageData();
      return { isAuthenticated: true, ...response.data };
    }

    return {
      isAuthenticated: false,
      featuredCourses: mockFeaturedCourses,
      discountedCourses: mockDiscountedCourses,
    };
  };
